/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Faq_5_QInputs */

const en_pc_faq_5_q = /** @type {(inputs: Pc_Faq_5_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can it replace Photoshop?`)
};

const zh_pc_faq_5_q = /** @type {(inputs: Pc_Faq_5_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`它能替代 Photoshop 吗？`)
};

/**
* | output |
* | --- |
* | "Can it replace Photoshop?" |
*
* @param {Pc_Faq_5_QInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_faq_5_q = /** @type {((inputs?: Pc_Faq_5_QInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Faq_5_QInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_faq_5_q(inputs)
	return zh_pc_faq_5_q(inputs)
});
export { pc_faq_5_q as "pc.faq.5.q" }